
// src/components/Icon.js
import React from "react";
import { useNavigate } from 'react-router-dom';
import '../../src/style.css';
const Doctors_db = ({ icon, label, link }) => {


  const navigate = useNavigate();

  const handleClick = () => {
    if (link) {
      navigate(link);
    }
  };
  return (

<div className="custom-card mb-2" onClick={handleClick} style={{padding:'6px'}}>
<div className="row align-items-center">
<div className="col-12">
    <div className="text-center card-body">
      <p className="card-title" style={{fontSize:'15px'}}>{label}</p>
    </div>
  </div>
  </div>
  <div className="row align-items-center">
  <div className="col-12 text-center">
    <img src={icon} className="card-img-top" alt={label} />
  </div>

</div>
</div>
  );
};

export default Doctors_db;
